import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";

@Component({
  selector: "tickets-badge-button",
  templateUrl: "tickets-badge-button.html",
  styleUrls: ["../../shortcut-menu.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, AngularSvgIconModule],
})
export class TicketsBadgeButton {
  count = input.required<number>();
  open = output<void>();

  protected onClick(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.open.emit();
  }
}
